import React from 'react';

const ReportsAndCommissions = () => {
  return (
    <iframe
      src="https://v2-embednotion.com/Reports-Commissions-5d1e65a08fdd4c27a52d5f9287ee499f"
      title="Reports & Commissions"
      style={{
        width: '100%',
        height: '600px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        padding: 'none',
        boxShadow: '0 2px 2px #ccc '
      }}
    />
  );
};

export default ReportsAndCommissions;
